//  NODE_ENV определяется при сборке в файле package.json, раздел scripts {}
let urls = {};

console.log(window.location)

if (NODE_ENV === 'production') {

  if (window.location.protocol === "https:") {
    urls = {
      socketURL: "wss://" + window.location.host + "/ws",
      loginURL: window.location.protocol + "//" + window.location.host + "/login"
    };
  } else {
    urls = {
      socketURL: "ws://" + window.location.host + "/ws",
      loginURL: window.location.protocol + "//" + window.location.host + "/login"
    };
  }

} else {
  urls = {
    socketURL: "ws://localhost:10000/ws",
    loginURL: "http://localhost:10000/login"
  };
}


if (NODE_ENV === 'production') {
  console.log('There is Production mode');
} else {
  console.log('There is Development mode');
}

export default urls




// WEBPACK FOOTER //
// ./src/const.js